import { render, staticRenderFns } from "./inviterecorddialog.vue?vue&type=template&id=770aa0f2&scoped=true"
import script from "./inviterecorddialog.vue?vue&type=script&lang=js"
export * from "./inviterecorddialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770aa0f2",
  null
  
)

export default component.exports